module.exports = __webpack_public_path__ + "static/media/checkScope_4.ff00f529.png";